/*
 * ---------------------------------------------------------------------------
 *
 * COPYRIGHT (c) 2026 IBS Software Canada Inc. All Rights Reserved.
 *
 * The copyright to the computer program(s) herein is the property of
 * IBS Software Canada Inc. The program(s) may be used and/or copied
 * only with the written permission from IBS Software Canada Inc.
 * or in accordance with the terms and conditions stipulated in the
 * agreement/contract under which the program(s) have been supplied.
 *
 * Date  : 2026-01-29
 *
 * ---------------------------------------------------------------------------
 */

import CrewGroupDefault from './components/CrewGroupDefault'

export default CrewGroupDefault;
